import { Col, Row } from "react-bootstrap";
import HoverCard from "../../../shared/HoverCard";
import { TbWriting } from "react-icons/tb";
import { MdOutlineQrCode2 } from "react-icons/md";

const QrOrManuel = ({data, setData, formError, setFormError}) => {
    
    return (
        <>
            <Row className="py-3" style={formError.choice && {border: "1px solid red"}}>
                <Col xs="12" md="6" xl="6">
                    <HoverCard
                        color="primary"
                        icon={<TbWriting size={100} style={{strokeWidth: 1}} />}
                        desc="Daten manuell eingeben"
                        isSelected={data.choice === "manuel"}
                        clickHandler={() => {
                            data.choice === "manuel"?
                                setData(prev => ({...prev, choice: ""})):
                                setData(prev => ({...prev, choice: "manuel"}));
                            setFormError({});
                        }}
                    />
                </Col>
                <Col xs="12" md="6" xl="6">
                    <HoverCard
                        color="energo"
                        icon={<MdOutlineQrCode2 size={100} />}
                        desc="QR-Code scannen"
                        helperText="(Falls in Ihrem Sicherungskasten vorhanden)"
                        isSelected={data.choice === "QR"}
                        clickHandler={() => {
                            data.choice === "QR"?
                                setData(prev => ({...prev, choice: ""})) :
                                setData(prev => ({...prev, choice: "QR"}));
                            setFormError({});
                        }}
                    />
                </Col>
            </Row>
        </>
    )
}
export default QrOrManuel;